import { DatesAndPricesItem, DatesAndPrices } from '@ve/components/hotel/datesTabs/common/types/IMapForDatesTabsStore';
import { ProductType } from '@ve/types';

export default function (datesAndProducts: DatesAndPrices | null, selectedDate: string): DatesAndPricesItem | null {
    if (!datesAndProducts) return null;

    const isProductBySelectedDateExists = datesAndProducts[selectedDate]?.price;

    if (isProductBySelectedDateExists) return datesAndProducts[selectedDate];

    const productPriority: Record<ProductType, number> = {
        TourProduct: 1,
        RailwayTourProduct: 2,
        HotelOfferProduct: 3,
    };

    const groupedProductByTypeProduct = Object.values(datesAndProducts)
        .filter((product) => !!product?.price)
        .reduce((acc, product) => {
            if (!acc[product.type]) {
                acc[product.type] = [];
            }
            acc[product.type].push(product);
            return acc;
        }, {} as Record<ProductType, DatesAndPricesItem[]>);

    const sortProductsByPriority = Object.values(groupedProductByTypeProduct)
        .sort((productsFirst, productsSecond) => {
            const firstProductType = productPriority[productsFirst[0].type];
            const secondProductType = productPriority[productsSecond[0].type];
            return firstProductType - secondProductType;
        });

    const foundMinPriceProduct = sortProductsByPriority[0]?.reduce((minPriceProduct, product) => {
        if (minPriceProduct.price > product.price) {
            minPriceProduct = product;
        }
        return minPriceProduct;
    }, sortProductsByPriority[0][0]);

    return foundMinPriceProduct || null;
}